import { __assign } from './../../external_lib/tslib/tslib.es6.js';
import Icon from '../../Atoms/Icon.js';
import React__default from 'react';

function FacebookUncoloredIcon(props) {
    return (React__default.createElement(Icon, __assign({ width: 24, height: 24, svg: function () {
            return "\n        <svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path d=\"M10.152 21.6H13.668V12.84H16.608L17.052 9.43199H13.668V7.24799C13.668 6.26399 13.944 5.59199 15.36 5.59199H17.172V2.53199C16.86 2.49599 15.792 2.39999 14.544 2.39999C11.928 2.39999 10.152 3.99599 10.152 6.91199V9.43199H7.19995V12.84H10.152V21.6Z\" fill=\"black\"/>\n        </svg>\n        ";
        } }, props)));
}

export { FacebookUncoloredIcon as default };
//# sourceMappingURL=facebook-uncolored.icon.js.map
